import getState, { createPromise, formatNumber, generateGUID } from "../utils/MainHelper";
import { getHighestAge } from "../utils/minified/MinifiedHelper";
import MainServices from "./Main.services";
import TopLevelCacheServices from "./TopLevelCache.services";
import TrackFeatureServices from "./TrackFeature.services";
import WorkerServices from "./Worker.services";

class MinifiedServices {
    constructor() {
        this.sqs = "https://sqs.ap-southeast-1.amazonaws.com/788016873502/oneintelligence-persona";
        this.ongoingCall = {};
    }

    getHashId(requestBody) {
        return WorkerServices.getObjectID([requestBody, ["filename"]]);
    }

    async runPersonas(filename, requestBody, reLoad, hashId, forceSqs) {
        const { promise, resolve } = createPromise();

        const getFile = () => {
            MainServices.getFile(filename, "persona").then((resp) => {
                if (!resp) {
                    setTimeout(() => {
                        getFile();
                    }, 1000);
                    return;
                }
                if (resp.status === "error") {
                    console.log("Error", resp.data);
                    resolve("error");
                    return;
                }
                if (resp.status !== "done") {
                    setTimeout(() => {
                        getFile();
                    }, 1000);
                } else {
                    resolve({ resp, hashId });
                }
            });
        };
        if (!reLoad) {
            // const cache = await WorkerServices.checkIfHasCache([requestBody, ["filename"]]);
            // if (cache !== "nocache") return Promise.resolve(cache)
        }

        MainServices.sqsSendMessage(forceSqs || this.sqs, JSON.stringify(requestBody)).then(() => {
            setTimeout(() => {
                getFile();
            }, 3000);
        });

        return promise.then((response) => {
            if (response === "error" || response?.status === "error") {
                return "error"
            }
            const { resp } = response
            if (resp === "error" || resp?.status === "error") {
                return "error"
            } else {
                WorkerServices.setCache([resp, requestBody, ["filename"]]);
                return response
            }
        })
    }

    async getPersonas(data, type, reLoad, monitorCallBack = () => { }) {
        const state = getState();
        const { username } = MainServices.userDetails()
        const account = MainServices.getAccount()

        const { targets } = state.minified;
        const { country } = state.buildTargets.setup;
        const { list } = data;
        const filename = `personas~${account}~${username}~${generateGUID()}.json`;

        const requestBody = {
            username,
            account,
            filename,
            function: "persona",
            data: {
                master: targets.join(", "),
                country: country.name === "Global Medical" ? "Global" : country.name,
                age: getHighestAge(data).toString(),
                behaviors: list.reduce((acc, category) => {
                    category.children.forEach((behavior) => {
                        acc[behavior.item] = parseFloat(formatNumber(behavior.score, 2))
                    });
                    return acc
                }, {})
            }
        }

        const hashId = await this.getHashId(requestBody);
        if (reLoad) {
            delete this.ongoingCall[hashId]
        }

        monitorCallBack(requestBody, this.sqs + "/" + requestBody.function)

        if (this.ongoingCall[hashId]) {
            return this.ongoingCall[hashId]
        } else {
            const { promise, resolve } = createPromise();
            this.ongoingCall[hashId] = promise
            let prm = reLoad ? Promise.resolve() : TopLevelCacheServices.getMinifiedPersonasCache(type);
            prm.then((cacheResult) => {
                TrackFeatureServices.trackFeature("personas", requestBody.function, requestBody);
                if (cacheResult) return resolve(cacheResult);
                this.runPersonas(filename, requestBody, reLoad, hashId).then((response) => {
                    try {
                        if (response === "error") return resolve(response)
                        let { resp, hashId } = response
                        TopLevelCacheServices.setMinifiedPersonasCache(resp, type)
                        delete this.ongoingCall[hashId]
                        resolve(resp)
                    } catch (e) {
                        return resolve("error")
                    }
                })
            })
            return this.ongoingCall[hashId]
        }
    }

    async getPersonasImage(data, type, reLoad, monitorCallBack = () => { }) {
        const { username } = MainServices.userDetails()
        const account = MainServices.getAccount();
        const filename = `personaimage~${account}~${username}~${generateGUID()}.json`;
        const requestBody = {
            username,
            account,
            filename,
            function: "persona image discord",
            data: {
                ...data,
                Age: data.Age.toString()
            }
        }
        const hashId = await this.getHashId(requestBody);
        if (reLoad) {
            delete this.ongoingCall[hashId]
        }

        monitorCallBack(requestBody, this.sqs + "/" + requestBody.function)

        let mainPromise = Promise.resolve();
        if (this.ongoingCall[hashId]) {
            mainPromise = this.ongoingCall[hashId]
        } else {
            const { promise, resolve } = createPromise();
            this.ongoingCall[hashId] = promise
            let prm = reLoad ? Promise.resolve() : TopLevelCacheServices.getMinifiedPersonasImageCache(type);
            prm.then((cacheResult) => {
                if (cacheResult) return resolve(cacheResult);
                else this.runPersonas(filename, requestBody, reLoad).then((response) => {
                    if (response === "error") return resolve(response)
                    const { resp, hashId } = response
                    if (resp === "error" || resp?.status === "error") return resolve("error")
                    TopLevelCacheServices.setMinifiedPersonasImageCache(resp, type)
                    delete this.ongoingCall[hashId]
                    resolve(resp)
                })
            })
            mainPromise = this.ongoingCall[hashId]
        }

        return mainPromise.then((res) => {
            if (res !== "error") {
                if (res.data.includes("persona/")) {
                    return MainServices.getFile(res.data, "sqgpt", true).then((resp) => {
                        const imageUrl = URL.createObjectURL(new Blob([resp.Body]));
                        return {
                            ...res,
                            imageUrl
                        }
                    })
                }
            }
            return res
        })
    }

}

export default new MinifiedServices();
